// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-card {
  background-color: #f0f0f0; /* Default color */
  transition: background-color 0.3s ease-in-out;
}

.active-step {
  background-color: #007bff !important; /* Brighter blue when active */
  color: white !important;
  border: 2px solid #0056b3; /* Optional: Add a border for emphasis */
}
.nav-card_highlighted {
  background-color: #007bff !important; /* Brighter blue when active */
  color: white !important;
  border: 2px solid #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Integrationlibrary.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC,EAAE,8BAA8B;EACpE,uBAAuB;EACvB,yBAAyB,EAAE,wCAAwC;AACrE;AACA;EACE,oCAAoC,EAAE,8BAA8B;EACpE,uBAAuB;EACvB,yBAAyB;AAC3B","sourcesContent":[".nav-card {\r\n  background-color: #f0f0f0; /* Default color */\r\n  transition: background-color 0.3s ease-in-out;\r\n}\r\n\r\n.active-step {\r\n  background-color: #007bff !important; /* Brighter blue when active */\r\n  color: white !important;\r\n  border: 2px solid #0056b3; /* Optional: Add a border for emphasis */\r\n}\r\n.nav-card_highlighted {\r\n  background-color: #007bff !important; /* Brighter blue when active */\r\n  color: white !important;\r\n  border: 2px solid #0056b3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
